import { Heading, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { useTranslation } from "react-i18next";

interface NudgeHeaderProps {
    /** When true, uses negative margin to span full width inside a padded parent. */
    fullWidth?: boolean;
}

/**
 * Nudge header that encourages users to book more activities.
 * Displays custom branded text from theme settings if configured, otherwise falls back to a default translation.
 * @param fullWidth - Set to true when rendered inside a padded container so the background spans the full width.
 */
function NudgeHeader({ fullWidth = false }: NudgeHeaderProps) {
    const { t } = useTranslation();
    const { data: { themeSettings } = {} } = useExternalBookingSettings();

    const breakoutStyle = fullWidth
        ? { mx: `calc(${ThemeSpaceVariable.Medium} * -1)` as string }
        : {};

    if (themeSettings && themeSettings.nudgeText && themeSettings.nudgeText !== "") {
        return (
            <Heading
                as="h3"
                fontWeight="700"
                py={ThemeSpaceVariable.Small}
                px={ThemeSpaceVariable.Medium}
                mb={ThemeSpaceVariable.XSmall}
                bgColor={themeSettings?.colors.bookMoreBannerBackground}
                color={themeSettings?.colors.bookMoreBannerTextColor}
                {...breakoutStyle}
            >
                {themeSettings.nudgeText}
            </Heading>
        );
    }
    return (
        <Heading
            as="h3"
            px={ThemeSpaceVariable.Medium}
            fontWeight="medium"
            my={ThemeSpaceVariable.Small}
            {...breakoutStyle}
        >
            {t("selectActivity.wantToAddMore")}
        </Heading>
    );
}

export { NudgeHeader };
